import { Box, Text, theme } from '@bpba/ui-components';
import { Urls } from '../utils/Url';

type Props = {
  title: string;
  url: string;
};

export const SeccionVideoTutorialAdhesion: React.FC<Props> = ({ title, url }) => {



  return (

    <Box flexDirection={['column', 'column', 'row', 'row']} mb={"24px"}>
      <Box width={['100%', '100%', '50%', '50%']} height={['100px', '100px', 'auto', 'auto']} justifyContent={"center"} alignItems={"center"}>
        <Text fontSize={"28px"} lineHeight={"37px"} color={theme.colors.secondary[1]}>
          {title}
        </Text>
      </Box>

      <Box width={['100%', '100%', '50%', '50%']} height={"auto"} border={'4px solid #25B4BD'} borderRadius={'3px 12px'}>
        <div style={{ paddingBottom: '56.25%' }} >
          <iframe
            title="video-modal"
            style={{ position: 'absolute', borderRadius: "1px 8.1px" }}
            width="100%"
            height="100%"
            src={Urls.getYoutubeEmbedUrl( url+ '?feature=share')}
            allow="autoplay"
            allowFullScreen={true}

          />
        </div>
      </Box>
    </Box>

  );
};